import { Filters } from '@apps/accommodations/AccommodationsConsole.types';

/**
 * root query param in which all accommodations console query params are nested under
 */
export const ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY = 'acs';

export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000,
} as const;

export const DEFAULT_OCCUPANCY = {
  unitCount: 1,
  occupancies: [
    {
      adults: 2,
      childrenAges: [],
    },
  ],
};

export const DEFAULT_SEARCH_RADIUS = 4; // Default search radius in km

export const DEFAULT_LOCATION = {
  destination: 'San Francisco',
  lat: 37.7749,
  lng: -122.4194, // Default to San Francisco coordinates
};

export const QUERY_PARAM_KEYS = {
  checkin: 'checkin',
  checkout: 'checkout',
  destination: 'destination',
  lat: 'lat',
  lng: 'lng',
  radius: 'radius',
  rooms: 'rooms',
};

export const FILTER_QUERY_PARAM_KEYS = {
  FACILITIES: 'facilities',
  STAR_RATING: 'starRating',
  USER_RATING: 'userRating',
  PRICE_MIN: 'priceMin',
  PRICE_MAX: 'priceMax',
  CUG: 'cug',
  PICKED_BY_COUPLE: 'pickedByCouple',
};

export const DEFAULT_FILTERS: Filters = {
  facilities: [],
  starRating: [],
  userRating: [],
  priceRange: [PRICE_RANGE.MIN, PRICE_RANGE.MAX],
  cug: false,
  pickedByCouple: false,
};

export const SORT_QUERY_PARAM_KEY = 'sort';
